module.exports = __webpack_public_path__ + "img/47_ProLabel_POM.6968d785.png";